module.exports = __webpack_public_path__ + "img/2.a3d1c01d.jpeg";